import React, { Fragment, useEffect } from 'react';
import { useFormikContext } from 'formik';
import * as yup from 'yup';
import { t } from 'Src/i18n';
import { PaymentMethodsCardList } from 'Components/widgets/payment-info/payment-method/PaymentMethodsCardList';
import { PaymentMethodsCardListPaymentProvider } from 'Components/widgets/payment-info/payment-method/PaymentMethodsCardListPaymentProvider';
import { FormFeedback } from 'Components/frameworks/form-feedback/FormFeedback';
type Props = {
  isPaymentProvider?: boolean;
  paymentProvider: PaymentProvider;
  shouldSubmitFormOnPaymentChosen: boolean;
};
const requiredRule = yup.string().required();
export const PaymentMethods = ({
  paymentProvider,
  shouldSubmitFormOnPaymentChosen,
  isPaymentProvider = false,
}: Props) => {
  const formik = useFormikContext();
  const CardListComponent = isPaymentProvider
    ? PaymentMethodsCardListPaymentProvider
    : PaymentMethodsCardList;
  useEffect(() => {
    const accordingPaymentMethod = paymentProvider.paymentMethods.find(
      ({ id }) => id === formik.values.paymentMethodId,
    );

    if (formik.values.paymentMethodId && accordingPaymentMethod) {
      formik.setFieldValue(
        'paymentConditionId',
        accordingPaymentMethod.timePaymentConditions[0].id,
      );
    }
  }, [formik.values.paymentMethodId]);
  return (
    <Fragment>
      <CardListComponent
        paymentProvider={paymentProvider}
        requiredRule={requiredRule}
        shouldSubmitFormOnPaymentChosen={shouldSubmitFormOnPaymentChosen}
      />
      {((formik.errors?.paymentMethodId && formik.touched?.paymentMethodId) ||
        (formik.errors?.paymentConditionId && formik.touched?.paymentConditionId)) && (
        <FormFeedback
          isError
          message={t('booking.banking.paymentMethod.errorMessageSelectCardType')}
        />
      )}
    </Fragment>
  );
};
